import { ApiQueryParams } from '@frontend/api-utils';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { CommonMessage } from '@frontend/lang';
import { UserClient } from '@frontend/user/api';
import { IUser, UserQueryParams } from '@frontend/user/types';
import { User } from '@frontend/user/utils';
import React, { useState } from 'react';

const ID = 'user-select';
export interface UserSelectProps extends ObjectSelectV2Props<IUser, UserQueryParams> {
    id?: string;
    label?: React.ReactNode;
    helpMessage?: React.ReactNode;
    required?: boolean;
    submitted: boolean;
    onChange?: (newValue: string | null) => void;
    onChangeObject?: (newValue: IUser | null) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<UserQueryParams>;
    subset?: string[];
}
/**
 * @deprecated
 */
export const UserSelect = (props: UserSelectProps) => {
    const [v, cV] = useState<IUser | null>(null);
    return (
        <ObjectSelectInputV2<IUser, UserQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.USER.DEFAULT}
            helpMessage={props.helpMessage}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            disabled={props.disabled}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            isClearable={props.isClearable}
            idValue={props.value || v?.id}
            fetch={(arg) => UserClient.fetchUsers({ ...arg, sort_field: 'first_name', sort_direction: 'asc' })}
            itemLabel={(user) => new User(user).getDisplayName()}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'user_id',
                          fetch: (id) =>
                              UserClient.resolveUsers([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
            subset={props.subset}
        />
    );
};
